import { createSelector } from 'reselect'

/**
 * @deprecated
 */
const selectBookingSummariesById = (state) => state.resources.BookingSummariesReducer.byId

/**
 * @deprecated
 */
export const selectBookingSummary = (bookingSummaryId) =>
  createSelector([selectBookingSummariesById], (byId = {}) => byId[bookingSummaryId])
